import { OptionsDTO } from '../../../src_server/entity/dto/OptionsDTO';


import { NotifyLogs } from '../../../src_server/entity/generated/NotifyLogs';


import { LessonMessageDTO } from '../../../src_server/entity/dto/LessonMessageDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class LessonMessageService extends GeneratedBizBase{
  async getContactListForTeacher(user_id: string): Promise<Response<OptionsDTO[]>> {
    return super.restCall<Response<OptionsDTO[]>>('get', '/v1/LessonMessageService/getContactListForTeacher', arguments);
  }
  async readYetMessage(user_id: string,message_list: number[]): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/LessonMessageService/readYetMessage', arguments);
  }
  async getSystemNotify(user_id: string): Promise<Response<NotifyLogs[]>> {
    return super.restCall<Response<NotifyLogs[]>>('get', '/v1/LessonMessageService/getSystemNotify', arguments);
  }
  async getMessages(user_id: string,user_type: string): Promise<Response<LessonMessageDTO[]>> {
    return super.restCall<Response<LessonMessageDTO[]>>('get', '/v1/LessonMessageService/getMessages', arguments);
  }
  async noLessonMessageSend(teacher_user_id: string,student_user_id: string,from_user_id: string,message_contents: string,building: string): Promise<Response<any>> {
    return super.restCall<Response<any>>('post', '/v1/LessonMessageService/noLessonMessageSend', arguments);
  }
  async send(class_id: number,from_user_id: string,message_contents: string,building: string): Promise<Response<LessonMessageDTO>> {
    return super.restCall<Response<LessonMessageDTO>>('post', '/v1/LessonMessageService/send', arguments);
  }
}
